import { Color, Texture } from "three";

const TEXT_RESOLUTION = 96;

export const createCanvasTexture = (text: string, color: Color): Texture | null => {
	var canvas = document.createElement("canvas"),
		ctx = canvas.getContext("2d");
	if (ctx !== null) {
		// Text in canvas: https://developer.mozilla.org/fr/docs/Web/API/Canvas_API/Tutoriel_canvas/Dessin_de_texte_avec_canvas
		canvas.height = canvas.width = TEXT_RESOLUTION;
		const fontSize = canvas.height / 2;
		const hsl = { h: 0, s: 0, l: 0 };
		color.getHSL(hsl);
		if (hsl.l < 0.4) {
			hsl.l = 0.4;
		}
		const { h, s, l } = hsl;
		ctx.fillStyle = `hsl(${h * 360},${s * 100}%,${l * 100}%)`;
		ctx.fillRect(0, 0, canvas.width, canvas.height);
		ctx.font = fontSize + "px serif";
		ctx.fillStyle = `hsl(${h * 360},${s * 100}%,${(l / 2) * 100}%)`;
		const textMesure = ctx.measureText(text);
		ctx.fillText(
			text,
			Math.max(canvas.width / 2 - textMesure.width / 2, 0),
			canvas.height / 2 +
				textMesure.actualBoundingBoxAscent / 2 -
				textMesure.actualBoundingBoxDescent / 2,
			canvas.width
		);
		var texture = new Texture(canvas);
		texture.needsUpdate = true;
		return texture;
	}
	return null;
};
